<template>
  <div>
    <StateTab
      :items="items"
      :columns="columns"
      :captionTab = "captiontable"
      :isCalled="false"
      :selectedValue="selectedItem"
      @editItem="showEditDialog"
      v-model="selectedItem"
      :captionSpr="captionSport"
      :urls="urls"
      ref="EventTab"
    >
    </StateTab>

    <b-modal ref="editModal" v-model="modalEditOpened" title="Редактирование состояния мероприятия" size="lg" hide-footer
             id="editModal">
      <div class="d-block">
        <label class="mb-1">Наименование</label>
        <b-form-invalid-feedback :state="validValue.fio">Указано пустое наименование</b-form-invalid-feedback>
        <b-form-input class="mb-2" type="text" placeholder="Укажите наименование" v-model="selectedItem.nameState"/>
      </div>
      <div class="d-block">
        <label class="mb-1">Описание</label>
        <b-form-input class="mb-2" type="text" placeholder="Укажите описание" v-model="selectedItem.descriptionState"/>
      </div>
      <b-button class="mt-3" variant="outline-primary" block @click="saveKind">Сохранить</b-button>
      <b-button class="mt-3" variant="outline-danger" block @click="modalEditOpened=!modalEditOpened">Отменить

      </b-button>
    </b-modal>

  </div>
</template>

<script>
  import StateTab from '@/components/TabSpr.vue'
  import http from '@/http-common'

  export default {
    name: 'EventState',
    components: {StateTab},
    data() {
      return {
          captiontable:'Состояния мероприятий',
        items: [],
        editItem: {},
        urls: {
          save: '/eventstate/save',
          delete: '/eventstate',
        },
        captionSport: {
          name: 'Состояние мероприятий',
          nameR: 'состояния мероприятия'
        },
        columns: [
          {key: 'nameState', label: 'Наименование'},
          {key: 'descriptionState', label: 'Описание'},
          {key: 'edit_field', label: ''}
        ],
        selectedItem: {id: 0},
        modalEditOpened: false,
        validValue: {
          name: true,
          form: true,
        }
      }
    },
    created() {
      this.loadItems();
    },
    methods: {
      checkForm() {
        for (var key in this.validValue) {
          this.validValue[key] = true;
        }
        if (!this.selectedItem.nameState || this.selectedItem.nameState == '') {
          this.validValue.name = false;
          this.validValue.form = false;
        }
      },
      loadItems() {
        var vm = this;
        http.get('/eventstate/list')
          .then((response) => {
            vm.items = response.data;
          })
          .catch((error) => console.log(error.response.data));
      },
      showEditDialog() {
        this.modalEditOpened = !this.modalEditOpened;
      },
      saveKind() {
        this.checkForm();
        if (this.validValue.form) {
          this.modalEditOpened = false;
          this.$refs.EventTab.save(this.selectedItem);
        }
      }
    }
  }
</script>
